<template>
  <v-card height="100%">
    <v-tabs
      v-show="false"
      v-model="currentStep"
      centered
      grow
      :hide-slider="true"
      :transition="false"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#1"
             :align-with-title="true"
             :disabled="disabled.firstTab"
      >
        ステップ1
      </v-tab>
      <v-tab href="#2"
             :align-with-title="true"
             :disabled="disabled.secondTab"
      >
        ステップ2
      </v-tab>
      <v-tab href="#3"
             :align-with-title="true"
             :disabled="disabled.thirdTab"
      >
        ステップ3
      </v-tab>
      <v-tab href="#4"
             :align-with-title="true"
             :disabled="disabled.fourthTab"
      >
        ステップ5
      </v-tab>
      <v-tab href="#5"
             :align-with-title="true"
             :disabled="disabled.fifthTab"
      >
        ステップ6
      </v-tab>
      <v-tab href="#6"
             :align-with-title="true"
             :disabled="disabled.sixthTab"
      >
        ステップ7
      </v-tab>
      <v-tab href="#7"
             :align-with-title="true"
             :disabled="disabled.seventhTab"
      >
        ステップ7
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentStep" :touch="onTouchEvent()">
      <v-tab-item id="1" value="1">
        <reservation-profile
          :current-step.sync="currentStep"
          :is-force-validate.sync="isForceValidate"
          :user-id="values.userId"
          :values="values.profiles"
          @onHandleChange="onChangeValueProfile"
          @nextToStep="nextToStep"
          @setUserId="setUserId"
          @onValidateSwipe="onValidateSwipe"
          @startLoading="startLoading"
          @endLoading="endLoading"
        >
        </reservation-profile>
      </v-tab-item>
      <v-tab-item id="2" value="2">
        <reservation-address
          :current-step.sync="currentStep"
          :values="values.address"
          :is-force-validate.sync="isForceValidate"
          :user-id="values.userId"
          @nextToStep="nextToStep"
          @prevToStep="prevToStep"
          @onHandleChange="onChangeValueAddress"
          @onValidateSwipe="onValidateSwipe"
          @startLoading="startLoading"
          @endLoading="endLoading"
        ></reservation-address>
      </v-tab-item>
      <v-tab-item id="3" value="3">
        <reservation-info
          :current-step.sync="currentStep"
          :studio="values.address.studio"
          :user-id="values.userId"
          @prevToStep="prevToStep"
          @nextToStep="onChangeValueContent"
          @onValidateSwipe="onValidateSwipe"
          @onChangeDesignCut="onChangeDesignCut"
          @onChangeConclusion="onChangeConclusion"
          @disableSwipeRight="disableSwipeRight"
          @startLoading="startLoading"
          @endLoading="endLoading"
        ></reservation-info>
      </v-tab-item>
      <v-tab-item id="4" value="4">
        <reservation-special v-if="isDesignCut || isConclusion"
                             :current-step.sync="currentStep"
                             :studio="values.address.studio"
                             :user-id="values.userId"
                             :is-conclusion.sync="isConclusion"
                             :treatment-content="values.treatmentContent"
                             :is-force-validate.sync="isForceValidate"
                             @prevToStep="prevToStep"
                             @nextToStep="onChangeValueContent"
                             @onValidateSwipe="onValidateSwipe"
                             @onHandleChange="onHandleChange"
                             @startLoading="startLoading"
                             @endLoading="endLoading"
        ></reservation-special>
        <reservation-time v-else
                          :time-visited="values.timeVisited"
                          :current-step.sync="currentStep"
                          :user-id="values.userId"
                          :studio="values.address.studio"
                          :is-force-validate.sync="isForceValidate"
                          :is-design-cut.sync="isDesignCut"
                          :is-conclusion.sync="isConclusion"
                          :treatment-content="values.treatmentContent"
                          :reservation-id="values.reservationId"
                          @setReservationId="setReservationId"
                          @setDuration="setDuration"
                          @nextToStep="nextToStep"
                          @prevToStep="prevToStep"
                          @onHandleChange="onChangeValueTimes"
                          @onValidateSwipe="onValidateSwipe"
                          @disableSwipeRight="disableSwipeRight"
                          @startLoading="startLoading"
                          @endLoading="endLoading"
        ></reservation-time>
      </v-tab-item>
      <v-tab-item id="5" value="5">
        <reservation-time v-if="isDesignCut || isConclusion"
                          :current-step.sync="currentStep"
                          :time-visited="values.timeVisited"
                          :studio="values.address.studio"
                          :user-id="values.userId"
                          :is-force-validate.sync="isForceValidate"
                          :is-design-cut="isDesignCut"
                          :is-conclusion.sync="isConclusion"
                          :treatment-content="values.treatmentContent"
                          :reservation-id="values.reservationId"
                          @setReservationId="setReservationId"
                          @setDuration="setDuration"
                          @nextToStep="nextToStep"
                          @prevToStep="prevToStep"
                          @onHandleChange="onChangeValueTimes"
                          @onValidateSwipe="onValidateSwipe"
                          @disableSwipeRight="disableSwipeRight"
                          @startLoading="startLoading"
                          @endLoading="endLoading"
        ></reservation-time>
        <reservation-question v-else
                              :is-force-validate.sync="isForceValidate"
                              :is-conclusion.sync="isConclusion"
                              :current-step.sync="currentStep"
                              :user-id="values.userId"
                              :values="values.answers"
                              :reminder-id="values.reminderId"
                              @setReminderId="setReminderId"
                              @nextToStep="nextToStep"
                              @prevToStep="prevToStep"
                              @onHandleChange="onChangeValueAnswers"
                              @onValidateSwipe="onValidateSwipe"
                              @startLoading="startLoading"
                              @endLoading="endLoading"
        ></reservation-question>
      </v-tab-item>
      <v-tab-item id="6" value="6">
        <reservation-question v-if="isConclusion"
                              :is-force-validate.sync="isForceValidate"
                              :is-conclusion.sync="isConclusion"
                              :current-step.sync="currentStep"
                              :user-id="values.userId"
                              :values="values.answers"
                              :reminder-id="values.reminderId"
                              @setReminderId="setReminderId"
                              @nextToStep="nextToStep"
                              @prevToStep="prevToStep"
                              @onHandleChange="onChangeValueAnswers"
                              @onValidateSwipe="onValidateSwipe"
                              @startLoading="startLoading"
                              @endLoading="endLoading"
        ></reservation-question>
        <reservation-next-question v-else
                                   :is-design-cut.sync="isDesignCut"
                                   :is-conclusion.sync="isConclusion"
                                   :current-step.sync="currentStep"
                                   :is-force-validate.sync="isForceValidate"
                                   :values="values.answers"
                                   :user-id="values.userId"
                                   :survey-id="values.surveyId"
                                   @setSurveyId="setSurveyId"
                                   @nextToStep="nextToStep"
                                   @prevToStep="prevToStep"
                                   @onHandleChange="onChangeValueAnswers"
                                   @onValidateSwipe="onValidateSwipe"
                                   @nextToPage="nextToPage"
                                   @startLoading="startLoading"
                                   @endLoading="endLoading"
        ></reservation-next-question>
      </v-tab-item>
      <v-tab-item id="7" value="7">
        <reservation-next-question
          v-if="isConclusion"
          :current-step.sync="currentStep"
          :is-force-validate.sync="isForceValidate"
          :is-conclusion.sync="isConclusion"
          :values="values.answers"
          :user-id="values.userId"
          :survey-id="values.surveyId"
          @setSurveyId="setSurveyId"
          @nextToStep="nextToStep"
          @prevToStep="prevToStep"
          @onHandleChange="onChangeValueAnswers"
          @onValidateSwipe="onValidateSwipe"
          @nextToPage="nextToPage"
          @startLoading="startLoading"
          @endLoading="endLoading"
        ></reservation-next-question>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
  import ReservationProfile from './ReservationProfile'
  import ReservationAddress from './ReservationAddress'
  import ReservationInfo from './ReservationInfo'
  import ReservationTime from './ReservationTime'
  import ReservationQuestion from './ReservationQuestion'
  import ReservationNextQuestion from './ReservationNextQuestion'
  import ReservationSpecial from './ReservationSpecial'

  export default {
    name: 'ReservationComponent',
    components: {
      ReservationSpecial,
      ReservationNextQuestion,
      ReservationQuestion,
      ReservationTime,
      ReservationInfo,
      ReservationAddress,
      ReservationProfile,
    },
    data() {
      return {
        currentStep: '1',
        isForceValidate: false,
        isDisabledSwipe: false,
        isDesignCut: false,
        isConclusion: false,
        disabled: {
          firstTab: false,
          secondTab: true,
          thirdTab: true,
          fourthTab: true,
          fifthTab: true,
          sixthTab: true,
          seventhTab: true,
          eighthTab: true,
        },
        values: {
          reservationId: '',
          duration: '',
          reminderId: '',
          surveyId: '',
          userId: '',
          profiles: {
            firstName: '',
            lastName: '',
            firstNameKana: '',
            lastNameKana: '',
            gender: '',
            email: '',
            phone: '',
            year: '',
            month: '',
            date: '',
          },
          address: {
            zipCode: '',
            address: '',
            state: '',
            city: '',
            studio: '',
            studioName: '',
            region_id: '',
          },
          treatmentContent: [],
          timeVisited: {
            firstTime: {
              date: '',
              hour: '',
              minute: '',
            },
            secondTime: {
              date: '',
              hour: '',
              minute: '',
            },
          },
          answers: {
            other: '',
            question: '',
            contact: '',
            experience: '',
            service: [],
            request: '',
          },
        },
      }
    },
    watch: {
      currentStep(newVal) {
        window.scrollTo(0, 0)
        this.isForceValidate = false
        switch (newVal) {
          case '2':
            this.disabled.secondTab = false
            break
          case '3':
            this.disabled.thirdTab = false
            break
          case '4':
            this.disabled.fourthTab = false
            break
          case '5':
            this.disabled.firstTab = false
            break
          case '6':
            this.disabled.sixthTab = false
            break
          case '7':
            this.disabled.seventhTab = false
            break
          case '8':
            this.disabled.eighthTab = false
            break
          default:
            this.disabled.firstTab = false
            break
        }
      },
    },
    created() {
      this.$emit('setTitle', 'MEN\'S SVENSON｜ご来店予約')
      if (this.$reservation.getCurrentStep()) {
        this.values = this.$reservation.getValuesReservation()
        this.isDesignCut = this.$reservation.getIsDesignCut()
        this.currentStep = this.$reservation.getCurrentStep()
        this.isConclusion = this.$reservation.getIsConclusion()
      }
    },
    methods: {
      assignSwipeLeft() {
        if (!this.isDisabledSwipe) {
          this.isForceValidate = true
        }
      },
      assignSwipeRight() {
        this.isForceValidate = false
        if (!this.isDisabledSwipe) {
          this.prevToStep()
        }
      },
      disableSwipeRight(value) {
        this.isDisabledSwipe = value
      },
      nextToStep() {
        const nextStep = parseInt(this.currentStep) + 1
        this.currentStep = nextStep.toString()
      },
      prevToStep() {
        const prevStep = parseInt(this.currentStep) - 1
        this.currentStep = prevStep.toString()
      },
      onHandleChange(field, value) {
        this.values[field] = value
      },
      onChangeValueProfile(field, value) {
        this.values.profiles[field] = value
      },
      onChangeValueAddress(field, value) {
        this.values.address[field] = value
      },
      onChangeValueAnswers(field, value) {
        this.values.answers[field] = value
      },
      onChangeValueTimes(field, value) {
        this.values.timeVisited[field] = value
      },
      onChangeValueContent(value, isNextStep = true) {
        this.values.treatmentContent = value
        if (isNextStep) {
          this.nextToStep()
        }
      },
      onChangeDesignCut(value) {
        this.isDesignCut = value
      },
      startLoading() {
        this.$emit('startLoading')
      },
      endLoading() {
        this.$emit('endLoading')
      },
      setUserId(value) {
        this.values.userId = value
      },
      setReservationId(value) {
        this.values.reservationId = value
      },
      setDuration(value) {
        this.values.duration = value
      },
      setReminderId(value) {
        this.values.reminderId = value
      },
      setSurveyId(value) {
        this.values.surveyId = value
      },
      onValidateSwipe(value) {
        this.isForceValidate = value
      },
      onChangeConclusion(value) {
        this.isConclusion = value
      },
      onTouchEvent() {
        return {
          left: () => this.assignSwipeLeft(),
          right: () => this.assignSwipeRight(),
        }
      },
      nextToPage() {
        this.$reservation.setCurrentStep(this.currentStep)
        this.$reservation.setIsDesignCut(this.isDesignCut)
        this.$reservation.setIsConclusion(this.isConclusion)
        this.$reservation.setValuesReservation(this.values)
        this.$router.push({
          name: 'reservation-confirm',
        })
      },
    },
  }
</script>
<style>
  .v-window.v-item-group.theme--light.v-tabs-items {
    height: 100%;
  }
</style>

